module.exports = __webpack_public_path__ + "static/media/wrong.2d54f43c.mp3";